export type ConsumerRuntimeDeviceMode = "kiosk" | "table";

const MODE_KEY = "consumerRuntimeDeviceMode";
const TABLE_CODE_KEY = "consumerRuntimeTableCode";

const toText = (value: unknown): string => String(value || "").trim();

export const readConsumerRuntimeDeviceMode = (): ConsumerRuntimeDeviceMode => {
  const stored = toText(localStorage.getItem(MODE_KEY)).toLowerCase();
  return stored === "table" ? "table" : "kiosk";
};

export const writeConsumerRuntimeDeviceMode = (mode: ConsumerRuntimeDeviceMode): void => {
  localStorage.setItem(MODE_KEY, mode);
};

export const readConsumerRuntimeTableCode = (): string => toText(localStorage.getItem(TABLE_CODE_KEY));

export const writeConsumerRuntimeTableCode = (tableCode: string): void => {
  const scoped = toText(tableCode);
  if (scoped) localStorage.setItem(TABLE_CODE_KEY, scoped);
  else localStorage.removeItem(TABLE_CODE_KEY);
};

export const clearConsumerRuntimeModeSetup = (): void => {
  localStorage.removeItem(MODE_KEY);
  localStorage.removeItem(TABLE_CODE_KEY);
};
